const postMessage = (message) => {
  if (!message) console.error('Missing postMessage string parameter')

  try {
    globalThis.webkit.messageHandlers.iosAuthTokenListener.postMessage(message)
  } catch (error) {
    console.error('iOS postMessage:', error)
  }
  try {
    globalThis.androidListener.postMessage(message)
  } catch (error) {
    console.error('Android postMessage:', error)
  }
}

const onBackButtonClicked = () => {
  try {
    globalThis.webkit.messageHandlers.iosUIListener.postMessage('onBackButtonClicked')
  } catch (error) {
    console.error('iOS onBackButtonClicked:', error)
  }
  try {
    globalThis.androidListener.onBackButtonClicked()
  } catch (error) {
    console.error('Android onBackButtonClicked:', error)
  }
}

const onForgotPasswordClicked = () => {
  try {
    globalThis.webkit.messageHandlers.iosUIListener.postMessage('onForgotPasswordClicked')
  } catch (error) {
    console.error('iOS onForgotPasswordClicked:', error)
  }
  try {
    globalThis.androidListener.onForgotPasswordClicked()
  } catch (error) {
    console.error('Android onForgotPasswordClicked:', error)
  }
}
export { onBackButtonClicked, onForgotPasswordClicked, postMessage }
